import styled from "styled-components";
import appConfig from "../../lib/appConfig";
import colours from "../../lib/colours";
import { stageIcons, stageNames } from "../../lib/workflow";
import NavStage from "../molecules/NavStage";

const Nav = styled.nav`
  position: relative;
  background-color: ${colours.th1l1};
  width: ${appConfig.leftNavWidth}px;
  height: 100%;
  color: ${colours.white};
  z-index: 1;
`;

const StagesContainer = styled.div`
  margin-top: 80px;
`;

const Header = styled.header`
  padding: 12px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: default;
`;

interface IProps {
  title: string;
  stages: string[];
  stage: number;
  maxEnabledStage: number;
  setStage: any;
  dataPanelOpen: boolean;
  openDataPanel: any;
}

function LeftNav({
  title,
  stages,
  stage,
  maxEnabledStage,
  setStage,
  dataPanelOpen,
  openDataPanel,
}: IProps) {
  return (
    <Nav>
      <Header>{title}</Header>
      <StagesContainer>
        {stages.map((x, index) => (
          <NavStage
            key={index}
            stageId={index}
            name={stageNames[x]}
            icon={stageIcons[x]}
            active={index === stage}
            disabled={index > maxEnabledStage}
            dataPanelOpen={dataPanelOpen}
            onActivate={(stage: number) => {
              setStage(stage);
              openDataPanel();
            }}
          />
        ))}
      </StagesContainer>
    </Nav>
  );
}

export default LeftNav;
